import dynamic from "next/dynamic";
import TimelineTabsConfig from "./timeline-tabs-config";
import TimelineTabsAdvancedConfig from "./timeline-tabs-advanced-config";
const TimelineTabsComponent = dynamic(()=>import("./timeline-tabs-component"));
export default {
    TimelineTabsComponent,
    TimelineTabsConfig,
    TimelineTabsAdvancedConfig
};
